<template>
    <Modal class="variable-discount-modal"
           :title="titleKey"
           size="lg"
           icon="fa-badge-percent">
        <form class="form-v cols">
            <div class="cols__col--1-2">
                <div class="form-group">
                    <label class="control-label">
                        {{ l('VARIABLE_DISCOUNT.AMOUNT') }}
                    </label>
                    <NumPad v-model="amount"
                            :show-value-as-currency="true"
                            :show-sign-button="false"
                            :show-cash-buttons="true"></NumPad>
                </div>
            </div>
            <div class="cols__col--1-2">
                <div class="form-group">
                    <label class="control-label"
                           for="variable_discount__narrative">
                        {{ l('VARIABLE_DISCOUNT.NARRATIVE') }}
                    </label>
                    <textarea id="variable_discount__narrative"
                              v-model="narrative"
                              name="narrative"
                              rows="6"
                              class="form-control input-lg"
                              :required="true"></textarea>
                </div>

                <ErrorMessage v-if="error"
                              class="mt-1"
                              :error="error"></ErrorMessage>
            </div>
        </form>

        <template v-slot:footer>
            <div class="modl-footer">
                <SquareBtn size="lg"
                           class="cancel-btn"
                           @click="cancel">
                    {{ l('CANCEL') }}
                </SquareBtn>

                <SquareBtn color="primary"
                           size="lg"
                           @click="ok">
                    {{ l('OK') }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import ErrorMessage from '@/vue/components/Errors/ErrorMessage';
import Modal from '@/vue/components/Modals/Modal';
import NumPad from '@/vue/components/NumPad/NumPad';
import SquareBtn from '@/vue/components/SquareBtn';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'VariableDiscountModal',

    components: {
        Modal,
        SquareBtn,
        ErrorMessage,
        NumPad,
    },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        variableDiscount: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            /**
             * @type {number}
             */
            amount: this.variableDiscount.amount,

            /**
             * @type {string}
             */
            narrative: this.variableDiscount.narrative,

            /**
             * @type {Error|null}
             */
            error: null,

            /**
             * Upon opening the modal we know if we are editing an exiting discount if the amount
             * or narrative are already populated.
             */
            isEdit: this.variableDiscount.amount !== 0 || this.variableDiscount.narrative !== '',
        };
    },

    computed: {
        titleKey() {
            return this.isEdit ? 'VARIABLE_DISCOUNT.MODAL_TITLE--EDIT' : 'VARIABLE_DISCOUNT.MODAL_TITLE';
        },
    },

    methods: {
        ok() {
            this.error = null;

            try {
                this.variableDiscount.setAmount(this.amount);
                this.variableDiscount.setNarrative(this.narrative);
                this.resolve({ variableDiscount: this.variableDiscount });
            } catch (error) {
                this.error = error;
                console.log(error);
            }
        },
    },
};
</script>
